var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideKeyboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "keyboard-hide"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459,0H51C22.95,0,0,22.95,0,51v255c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z  M229.5,76.5h51v51h-51V76.5z M229.5,153h51v51h-51V153z M153,76.5h51v51h-51V76.5z M153,153h51v51h-51V153z M127.5,204h-51v-51 h51V204z M127.5,127.5h-51v-51h51V127.5z M357,306H153v-51h204V306z M357,204h-51v-51h51V204z M357,127.5h-51v-51h51V127.5z  M433.5,204h-51v-51h51V204z M433.5,127.5h-51v-51h51V127.5z M255,510l102-102H153L255,510z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideKeyboard);
export default __webpack_public_path__ + "static/media/hide-keyboard.a47726001e17ac977c3d9457b2b1636b.svg";
export { ForwardRef as ReactComponent };